/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2021 ООО АДАПТ info@acfs.spb.ru
 *
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import { FunctionComponent } from 'react'

import { ActNotification, useRouter } from '@builddocs/data-management'
import { UserInfoBubble } from '@builddocs/mui'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import CardContent from '@mui/material/CardContent'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'
import { format, parseISO } from 'date-fns'
import { ru } from 'date-fns/locale'

interface OwnProps {
  notification: ActNotification
}

type Props = OwnProps

const ActCreated: FunctionComponent<Props> = props => {
  const { notification } = props

  const { navigate } = useRouter()

  const urlMatches = /projects\/([\d\w-]+)\//gi.exec(
    notification.actEvent.actLocationUrl,
  )

  console.log(urlMatches)

  const createTime =
    notification.createDateTime &&
    format(parseISO(notification.createDateTime), 'PP', {
      locale: ru,
    })
  const createTimeFull =
    notification.createDateTime &&
    format(parseISO(notification.createDateTime), 'PPPpp', {
      locale: ru,
    })

  const goToActPage = () =>
    urlMatches &&
    navigate({
      pathname: `/projects/${urlMatches[1]}/contracts/${notification.actEvent.journalId}/acts`,
      search: '?workDocSection=' + notification.actEvent.workDocSection,
    })

  return (
    <Card key={notification.notificationTargetId} elevation={3}>
      <CardActionArea onClick={goToActPage}>
        <CardContent>
          <Stack direction="row" justifyContent="space-between">
            <Typography fontWeight="bold">
              <UserInfoBubble
                labelProps={{ component: 'span', color: 'text.primary' } as any}
                userId={notification.generator.userId}
              />{' '}
              сформировал акт №{notification.actEvent.actNumber}
            </Typography>
            <IconButton color="secondary" sx={{ m: -1 }}>
              {notification.viewed ? null : <FiberManualRecordIcon />}
            </IconButton>
          </Stack>
          <Stack direction="row" mt={1} spacing={3}>
            <Typography variant="caption">
              {`${notification.actEvent.journalTitle}`}
            </Typography>
            <Typography variant="caption">
              {`${notification.actEvent.workDocSection}`}
            </Typography>

            <Typography variant="caption">
              {createTime ? (
                <Tooltip title={createTimeFull}>
                  <span>{createTime}</span>
                </Tooltip>
              ) : undefined}
            </Typography>
          </Stack>
        </CardContent>
        {/*<CardActions>*/}
        {/*  {goToActPage && <Button onClick={goToActPage}>Перейти</Button>}*/}
        {/*</CardActions>*/}
      </CardActionArea>
    </Card>
  )
}

export default ActCreated
